import { render, staticRenderFns } from "./AiMsg.vue?vue&type=template&id=123fc7c9"
import script from "./AiMsg.vue?vue&type=script&lang=js"
export * from "./AiMsg.vue?vue&type=script&lang=js"
import style0 from "./AiMsg.vue?vue&type=style&index=0&id=123fc7c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports